export default __webpack_public_path__ + "static/media/lines-no-2.9c655af5.ogg";